import { render } from "./StockMovementDialog.vue?vue&type=template&id=db27acc4&scoped=true"
import script from "./StockMovementDialog.vue?vue&type=script&lang=js"
export * from "./StockMovementDialog.vue?vue&type=script&lang=js"

import "./StockMovementDialog.vue?vue&type=style&index=0&id=db27acc4&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db27acc4"]])

export default __exports__